<template>
  <app-bottom-sheet class="grid gap-4">
    <course-page-registration-actions
      v-if="nextSession"
      :course="course"
      :session="nextSession"
    />

    <course-page-actions v-else class="!gap-2" :course="course" />

    <p
      v-if="nextSessionFormattedStartDate"
      class="text-subtle -mt-2 text-center text-sm"
    >
      Prochaine session le
      <strong>{{ nextSessionFormattedStartDate }}</strong>
    </p>
  </app-bottom-sheet>
</template>

<script lang="ts" setup>
import type { CoursePageView } from "~/business-areas/course/course.model";
import type { CourseSessionView } from "~/business-areas/course-session/course-session.model";
import CoursePageActions from "~/pages/courses/[slug]/_includes/components/course-page-actions.vue";
import CoursePageRegistrationActions from "~/pages/courses/[slug]/_includes/components/registration/course-page-registration-actions.vue";

const properties = defineProps<{
  course: CoursePageView;
  nextSession?: CourseSessionView;
}>();

const nextSessionFormattedStartDate = computed(() => {
  if (!properties.nextSession) return;

  return useCourseSessionInfo(properties.nextSession).formattedDate.value;
});
</script>
